export default function formatPhoneNumber(phoneNumberString: string): string {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    let match
    if (cleaned.length !== 11) {
        match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phoneNumberString
    } else {
        match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/)
        return match ? `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}` : phoneNumberString
    }
}
